import React from 'react';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const ProductCard = styled(Box)({
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  borderRadius: 2,
  p: 4,
  flex: 1,
  backdropFilter: 'blur(10px)',
  transition: 'transform 0.3s ease, opacity 0.3s ease',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-8px)',
    opacity: 0.9,
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '3px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
});

export interface ProductCardProps {
  logo: string;
  alt: string;
  title: string;
  subtitle: string;
  description: string;
}

export const ProductCardContent: React.FC<ProductCardProps> = ({ logo, alt, title, subtitle, description }) => {
  const isProd = window.location.hostname !== 'localhost';
  const getProductUrl = () => {
    switch (alt) {
      case 'Zeller':
        return isProd ? 'https://zeller.ai' : 'http://localhost:3000';
      case 'Planer':
        return isProd ? 'https://planer.ai' : 'http://localhost:3002';
      case 'Siker':
        return 'https://siker.ai';
      default:
        return '#';
    }
  };

  return (
    <Box
      component="a"
      href={getProductUrl()}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        textDecoration: 'none',
        flex: 1,
        display: 'block',
      }}
    >
      <ProductCard>
        <Box
          component="img"
          src={logo}
          alt={alt}
          sx={{
            width: '150px',
            height: 'auto',
            mb: 3,
          }}
        />
        <Typography variant="h6" fontFamily="Jost" color="white" mb={1} fontWeight="bold">
          {title}
        </Typography>
        <Typography color="white" variant="body1" mb={2} fontWeight="bold">
          {subtitle}
        </Typography>
        <Typography color="white" variant="body2" sx={{ opacity: 0.8 }}>
          {description}
        </Typography>
      </ProductCard>
    </Box>
  );
};

export default ProductCardContent;
